var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var loadjs_umd = createCommonjsModule(function (module, exports) {
(function(root, factory) {
  {
    module.exports = factory();
  }
}(commonjsGlobal, function() {
/**
 * Global dependencies.
 * @global {Object} document - DOM
 */

var devnull = function() {},
    bundleIdCache = {},
    bundleResultCache = {},
    bundleCallbackQueue = {};


/**
 * Subscribe to bundle load event.
 * @param {string[]} bundleIds - Bundle ids
 * @param {Function} callbackFn - The callback function
 */
function subscribe(bundleIds, callbackFn) {
  // listify
  bundleIds = bundleIds.push ? bundleIds : [bundleIds];

  var depsNotFound = [],
      i = bundleIds.length,
      numWaiting = i,
      fn,
      bundleId,
      r,
      q;

  // define callback function
  fn = function (bundleId, pathsNotFound) {
    if (pathsNotFound.length) depsNotFound.push(bundleId);

    numWaiting--;
    if (!numWaiting) callbackFn(depsNotFound);
  };

  // register callback
  while (i--) {
    bundleId = bundleIds[i];

    // execute callback if in result cache
    r = bundleResultCache[bundleId];
    if (r) {
      fn(bundleId, r);
      continue;
    }

    // add to callback queue
    q = bundleCallbackQueue[bundleId] = bundleCallbackQueue[bundleId] || [];
    q.push(fn);
  }
}


/**
 * Publish bundle load event.
 * @param {string} bundleId - Bundle id
 * @param {string[]} pathsNotFound - List of files not found
 */
function publish(bundleId, pathsNotFound) {
  // exit if id isn't defined
  if (!bundleId) return;

  var q = bundleCallbackQueue[bundleId];

  // cache result
  bundleResultCache[bundleId] = pathsNotFound;

  // exit if queue is empty
  if (!q) return;

  // empty callback queue
  while (q.length) {
    q[0](bundleId, pathsNotFound);
    q.splice(0, 1);
  }
}


/**
 * Execute callbacks.
 * @param {Object or Function} args - The callback args
 * @param {string[]} depsNotFound - List of dependencies not found
 */
function executeCallbacks(args, depsNotFound) {
  // accept function as argument
  if (args.call) args = {success: args};

  // success and error callbacks
  if (depsNotFound.length) (args.error || devnull)(depsNotFound);
  else (args.success || devnull)(args);
}


/**
 * Load individual file.
 * @param {string} path - The file path
 * @param {Function} callbackFn - The callback function
 */
function loadFile(path, callbackFn, args, numTries) {
  var doc = document,
      async = args.async,
      maxTries = (args.numRetries || 0) + 1,
      beforeCallbackFn = args.before || devnull,
      pathname = path.replace(/[\?|#].*$/, ''),
      pathStripped = path.replace(/^(css|img)!/, ''),
      isLegacyIECss,
      e;

  numTries = numTries || 0;

  if (/(^css!|\.css$)/.test(pathname)) {
    // css
    e = doc.createElement('link');
    e.rel = 'stylesheet';
    e.href = pathStripped;

    // tag IE9+
    isLegacyIECss = 'hideFocus' in e;

    // use preload in IE Edge (to detect load errors)
    if (isLegacyIECss && e.relList) {
      isLegacyIECss = 0;
      e.rel = 'preload';
      e.as = 'style';
    }
  } else if (/(^img!|\.(png|gif|jpg|svg|webp)$)/.test(pathname)) {
    // image
    e = doc.createElement('img');
    e.src = pathStripped;    
  } else {
    // javascript
    e = doc.createElement('script');
    e.src = path;
    e.async = async === undefined ? true : async;
  }

  e.onload = e.onerror = e.onbeforeload = function (ev) {
    var result = ev.type[0];

    // treat empty stylesheets as failures to get around lack of onerror
    // support in IE9-11
    if (isLegacyIECss) {
      try {
        if (!e.sheet.cssText.length) result = 'e';
      } catch (x) {
        // sheets objects created from load errors don't allow access to
        // `cssText` (unless error is Code:18 SecurityError)
        if (x.code != 18) result = 'e';
      }
    }

    // handle retries in case of load failure
    if (result == 'e') {
      // increment counter
      numTries += 1;

      // exit function and try again
      if (numTries < maxTries) {
        return loadFile(path, callbackFn, args, numTries);
      }
    } else if (e.rel == 'preload' && e.as == 'style') {
      // activate preloaded stylesheets
      return e.rel = 'stylesheet'; // jshint ignore:line
    }
    
    // execute callback
    callbackFn(path, result, ev.defaultPrevented);
  };

  // add to document (unless callback returns `false`)
  if (beforeCallbackFn(path, e) !== false) doc.head.appendChild(e);
}


/**
 * Load multiple files.
 * @param {string[]} paths - The file paths
 * @param {Function} callbackFn - The callback function
 */
function loadFiles(paths, callbackFn, args) {
  // listify paths
  paths = paths.push ? paths : [paths];

  var numWaiting = paths.length,
      x = numWaiting,
      pathsNotFound = [],
      fn,
      i;

  // define callback function
  fn = function(path, result, defaultPrevented) {
    // handle error
    if (result == 'e') pathsNotFound.push(path);

    // handle beforeload event. If defaultPrevented then that means the load
    // will be blocked (ex. Ghostery/ABP on Safari)
    if (result == 'b') {
      if (defaultPrevented) pathsNotFound.push(path);
      else return;
    }

    numWaiting--;
    if (!numWaiting) callbackFn(pathsNotFound);
  };

  // load scripts
  for (i=0; i < x; i++) loadFile(paths[i], fn, args);
}


/**
 * Initiate script load and register bundle.
 * @param {(string|string[])} paths - The file paths
 * @param {(string|Function|Object)} [arg1] - The (1) bundleId or (2) success
 *   callback or (3) object literal with success/error arguments, numRetries,
 *   etc.
 * @param {(Function|Object)} [arg2] - The (1) success callback or (2) object
 *   literal with success/error arguments, numRetries, etc.
 */
function loadjs(paths, arg1, arg2) {
  var bundleId,
      args;

  // bundleId (if string)
  if (arg1 && arg1.trim) bundleId = arg1;

  // args (default is {})
  args = (bundleId ? arg2 : arg1) || {};

  // throw error if bundle is already defined
  if (bundleId) {
    if (bundleId in bundleIdCache) {
      throw "LoadJS";
    } else {
      bundleIdCache[bundleId] = true;
    }
  }

  function loadFn(resolve, reject) {
    loadFiles(paths, function (pathsNotFound) {
      // execute callbacks
      executeCallbacks(args, pathsNotFound);
      
      // resolve Promise
      if (resolve) {
        executeCallbacks({success: resolve, error: reject}, pathsNotFound);
      }

      // publish bundle load event
      publish(bundleId, pathsNotFound);
    }, args);
  }
  
  if (args.returnPromise) return new Promise(loadFn);
  else loadFn();
}


/**
 * Execute callbacks when dependencies have been satisfied.
 * @param {(string|string[])} deps - List of bundle ids
 * @param {Object} args - success/error arguments
 */
loadjs.ready = function ready(deps, args) {
  // subscribe to bundle load event
  subscribe(deps, function (depsNotFound) {
    // execute callbacks
    executeCallbacks(args, depsNotFound);
  });

  return loadjs;
};


/**
 * Manually satisfy bundle dependencies.
 * @param {string} bundleId - The bundle id
 */
loadjs.done = function done(bundleId) {
  publish(bundleId, []);
};


/**
 * Reset loadjs dependencies statuses
 */
loadjs.reset = function reset() {
  bundleIdCache = {};
  bundleResultCache = {};
  bundleCallbackQueue = {};
};


/**
 * Determine if bundle has already been defined
 * @param String} bundleId - The bundle id
 */
loadjs.isDefined = function isDefined(bundleId) {
  return bundleId in bundleIdCache;
};


// export
return loadjs;

}));
});

var asyncToGenerator = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _this = undefined;

var getPieEncryptionScriptType = function getPieEncryptionScriptType() {
  return window.vzFlags && window.vzFlags.isProd || window.location.hostname === 'www.verizon.com' || window.location.hostname === 'www.verizonwireless.com' ? 'PRODUCTION' : 'UAT';
};

var getPieEncryptionScriptUrls = function getPieEncryptionScriptUrls() {
  var type = getPieEncryptionScriptType();
  var pieEnvironmentURLs = {
    DEVELOPMENT: {
      encryption: 'https://voltage-pp-0000.dev.verizon.com/pie/v1/encryption.js',
      key: 'https://voltage-pp-0000.dev.verizon.com/pie/v1/verizon/getkey.js'
    },
    UAT: {
      encryption: 'https://pie.uat.verizon.com/pie/v1/encryption.js',
      key: 'https://pie.uat.verizon.com/pie/v1/verizon/getkey.js'
    },
    PRODUCTION: {
      encryption: 'https://pie.prod.verizon.com/pie/v1/encryption.js',
      key: 'https://pie.prod.verizon.com/pie/v1/verizon/getkey.js'
    }
  };

  if (type && pieEnvironmentURLs && pieEnvironmentURLs[type]) {
    return pieEnvironmentURLs[type];
  }
  return null;
};

var loadPieScripts = function loadPieScripts() {
  return new Promise(function (resolve) {
    var pieScripts = Object.values(getPieEncryptionScriptUrls() || {});
    var getKeyJsSuccess = true;
    var encryptionJsSuccess = true;
    var callback = function callback() {
      resolve({
        isSuccess: true,
        getKeyJsSuccess: getKeyJsSuccess,
        encryptionJsSuccess: encryptionJsSuccess
      });
    };

    if (pieScripts && pieScripts.length > 0) {
      // Loading Pie Scripts, first try
      loadjs_umd(pieScripts, { returnPromise: true }).then(callback).catch(function (initiallyFailedFiles) {
        console.debug('The following files failed to load: ', initiallyFailedFiles, '\n Retrying...');

        // Trying to reload the files that initially failed.
        loadjs_umd(initiallyFailedFiles, { returnPromise: true }).then(callback).catch(function (failedFiles) {
          console.debug('Retrying to load the following files failed: ', failedFiles);
          failedFiles.forEach(function (file) {
            if (file.includes('getkey.js')) {
              getKeyJsSuccess = false;
            } else if (file.includes('encryption.js')) {
              encryptionJsSuccess = false;
            }
          });
          resolve({
            isSuccess: false,
            getKeyJsSuccess: getKeyJsSuccess,
            encryptionJsSuccess: encryptionJsSuccess,
            failedFiles: failedFiles
          });
        });
      });
    } else {
      resolve({
        isSuccess: false,
        getKeyJsSuccess: false,
        encryptionJsSuccess: false,
        failedFiles: [],
        noScriptsMatchEnv: true
      });
    }
  });
};

var PIE_FAILED_REASON = {
  JS: 'PIE_JS_LOAD_FAILED',
  PAN: 'PAN_VALIDATION_FAILED',
  ENCRYPTION: 'PIE_ENCRYPTION_FAILED'
};

var ENCRYPTION_INPUT = {
  CC: 'creditcard',
  CVC: 'cvv', // just for easier logging
  CVV: 'cvv',
  GC_NUMBER: 'giftcardnumber',
  GC_PIN: 'giftcardpin',
  SSN: 'ssn',
  PIN: 'pin',
  PASSWORD: 'password'
};

var pieProtectPCI = function () {
  var _ref = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(creditCard, cvv) {
    var suffix, encryptedResult, creditCardInfo, _encryptedResult, _encryptedResult2, encryptedData, encryptedData2;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // PIE encryption
            suffix = 'PCC';
            encryptedResult = null;
            creditCardInfo = {
              encryptionStatus: {
                requestedInput: ENCRYPTION_INPUT.CC,
                validPANChecksum: false,
                errorType: null,
                isSuccess: false
              },
              pieFunctionStatus: {
                ValidatePANChecksum: !!window.ValidatePANChecksum,
                ProtectPANandCVV: !!window.ProtectPANandCVV,
                ProtectString: !!window.ProtectString
              }
            };

            // Check if methods are available, if not try to load them. If that fails then

            if (window.ValidatePANChecksum && window.ProtectPANandCVV) {
              _context.next = 11;
              break;
            }

            _context.next = 6;
            return loadPieScripts();

          case 6:
            creditCardInfo.pieFileStatus = _context.sent;

            creditCardInfo.pieFunctionStatus = {
              ValidatePANChecksum: !!window.ValidatePANChecksum,
              ProtectPANandCVV: !!window.ProtectPANandCVV,
              ProtectString: !!window.ProtectString
            };

            if (creditCardInfo.pieFileStatus.isSuccess) {
              _context.next = 11;
              break;
            }

            creditCardInfo.encryptionStatus.errorType = PIE_FAILED_REASON.JS;
            return _context.abrupt('return', creditCardInfo);

          case 11:
            if (window.ValidatePANChecksum && window.ProtectPANandCVV) {
              _context.next = 14;
              break;
            }

            creditCardInfo.encryptionStatus.errorType = PIE_FAILED_REASON.JS;
            return _context.abrupt('return', creditCardInfo);

          case 14:

            // Checks if creditCard is valid format, if not throw error.
            try {
              creditCardInfo.encryptionStatus.validPANChecksum = creditCard ? window.ValidatePANChecksum(creditCard) : false;
            } catch (e) {
              creditCardInfo.encryptionStatus.validPANChecksum = false;
              creditCardInfo.encryptionStatus.errorType = PIE_FAILED_REASON.PAN;
              creditCardInfo.encryptionStatus.pieJSError = {
                message: e.message,
                stack: e.stack,
                function: 'ValidatePANChecksum'
              };
            }

            // Panchecksum was a success, try encrypting the credit card.
            if (creditCardInfo.encryptionStatus.validPANChecksum) {
              try {
                encryptedResult = creditCard && window.ProtectPANandCVV ? window.ProtectPANandCVV(creditCard, cvv) : null;
              } catch (e) {
                encryptedResult = null;
                creditCardInfo.encryptionStatus.pieJSError = {
                  message: e.message,
                  stack: e.stack,
                  function: 'ProtectPANandCVV'
                };
              }

              // Check if encryption was a success and add it to the result
              if (encryptedResult !== null && Array.isArray(encryptedResult)) {
                _encryptedResult = encryptedResult, _encryptedResult2 = slicedToArray(_encryptedResult, 2), encryptedData = _encryptedResult2[0], encryptedData2 = _encryptedResult2[1];

                creditCardInfo.encryptedData = encryptedData + ' ' + encryptedData2 + ' ' + suffix;
                creditCardInfo.encryptedData2 = encryptedData2 + ' ' + suffix;
                creditCardInfo.encryptionStatus.isSuccess = true;
              } else {
                creditCardInfo.encryptionStatus.errorType = PIE_FAILED_REASON.ENCRYPTION;
              }
            } else {
              creditCardInfo.encryptionStatus.errorType = PIE_FAILED_REASON.PAN;
            }

            // Return Object
            return _context.abrupt('return', creditCardInfo);

          case 17:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function pieProtectPCI(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var pieProtectSPI = function () {
  var _ref2 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(data, requestedInput) {
    var suffix, encryptedResult, result;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            // PIE encryption
            suffix = 'PSS';

            // PIE encryption

            encryptedResult = null;
            result = {
              encryptedData: null,
              encryptionStatus: {
                requestedInput: requestedInput,
                errorType: null,
                isSuccess: false
              },
              pieFunctionStatus: {
                ValidatePANChecksum: !!window.ValidatePANChecksum,
                ProtectPANandCVV: !!window.ProtectPANandCVV,
                ProtectString: !!window.ProtectString
              }
            };

            // Check if methods are available, if not try to load them. If that fails then

            if (window.ProtectString) {
              _context2.next = 11;
              break;
            }

            _context2.next = 6;
            return loadPieScripts();

          case 6:
            result.pieFileStatus = _context2.sent;

            result.pieFunctionStatus = {
              ValidatePANChecksum: !!window.ValidatePANChecksum,
              ProtectPANandCVV: !!window.ProtectPANandCVV,
              ProtectString: !!window.ProtectString
            };

            if (result.pieFileStatus.isSuccess) {
              _context2.next = 11;
              break;
            }

            result.encryptionStatus.errorType = PIE_FAILED_REASON.JS;
            return _context2.abrupt('return', result);

          case 11:
            if (!window.ProtectString) {
              _context2.next = 24;
              break;
            }

            _context2.prev = 12;

            encryptedResult = window.ProtectString(data);
            if (encryptedResult) {
              result.encryptedData = encryptedResult[0] + ' ' + window.PIE.key_id + ' ' + window.PIE.phase + ' ' + suffix;
              result.encryptionStatus.isSuccess = true;
            } else {
              result.encryptionStatus.errorType = PIE_FAILED_REASON.ENCRYPTION;
            }
            _context2.next = 22;
            break;

          case 17:
            _context2.prev = 17;
            _context2.t0 = _context2['catch'](12);

            result.encryptionStatus.errorType = PIE_FAILED_REASON.ENCRYPTION;
            result.encryptionStatus.pieJSError = {
              message: _context2.t0.message,
              stack: _context2.t0.stack,
              function: 'ProtectString'
            };
            return _context2.abrupt('return', result);

          case 22:
            _context2.next = 25;
            break;

          case 24:
            result.encryptionStatus.errorType = PIE_FAILED_REASON.JS;

          case 25:
            return _context2.abrupt('return', result);

          case 26:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this, [[12, 17]]);
  }));

  return function pieProtectSPI(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

var getEncryptionError = function getEncryptionError(encryptedResponse) {
  // Ensure no encrypted data is being sent
  var extraParams = _extends({}, encryptedResponse);
  delete extraParams.encryptedData;
  delete extraParams.encryptedData2;

  return {
    subEventType: 'FeErrorPie',
    error: {
      extraParams: extraParams
    }
  };
};

export { loadPieScripts, PIE_FAILED_REASON, ENCRYPTION_INPUT, pieProtectPCI, pieProtectSPI, getEncryptionError };
